import { Injectable, OnDestroy } from '@angular/core';

import { LandingComm } from './landing-comm.model';

@Injectable()
export class SwitchboardService implements OnDestroy {
    private _landing: LandingComm;

    ngOnDestroy(): void {
        this._landing = null;
    }

    sbLandingConnect(instance: LandingComm): void {
        this._landing = instance;
    }

    sbLandingDidUpdate(draftId?: string, responseId?: number): void {
        this._landing?.sbLandingDidUpdate(draftId, responseId);
    }
}
